export default "__VITE_ASSET___TZ1rL1Z__"